import { Component, OnInit, TemplateRef } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AuthServiceService } from 'src/app/shared/services/auth-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { AlertService } from 'ngx-alerts';
import { CustomValidator } from 'src/app/validators/custom-validator';
import { OthersService } from 'src/app/shared/services/other-services/others.service';
import { AngularFireStorage } from '@angular/fire/storage';
import { finalize } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

export interface MicroLoanClient {
  customerComment: string;
  customerDateOfBirth: string;
  customerHomeAreaDetails: string;
  customerId: number;
  customerIdNumber: string;
  customerIdPhotoUrl: string;
  customerIdType: string;
  customerName: string;
  customerPhone1: string;
  customerPhone2: string;
  customerPhotoUrl: string;
  customerSecretPin: number;
  fkCustomerIdMicroLoanCustomer: number;
  fkproductCodeMicroloanCustomerId: number;
  fktheStationLocationIdCustomer: number;
  microloanCustomerAccrualDays: number;
  microloanCustomerAmortCyle: number;
  microloanCustomerAmortType: number;
  microloanCustomerAverageDailyExpenses: number;
  microloanCustomerAverageDailyIncome: number;
  microloanCustomerCurrentBusinessLocation: string;
  microloanCustomerCurrentBusinessType: string;
  microloanCustomerCurrentResidence: string;
  microloanCustomerId: number;
  microloanCustomerIntAccrualMethod: number;
  microloanCustomerLoanInterest: number;
  microloanCustomerLoanLimit: number;
  microloanCustomerLoanTenure: number;
  microloanCustomerNumberOfDependants: number;
  microloanCustomerResidenceStatus: string;
  photoUrlTenancyAgreementOrLandTitleSalesAgrement: string;
  productCodes: string;
}
@Component({
  selector: 'app-get-loan',
  templateUrl: './get-loan.component.html',
  styleUrls: ['./get-loan.component.scss'],
})
export class GetLoanComponent implements OnInit {
  modalRef: BsModalRef;
  registered = false;
  submitted = false;
  errored = false;
  posted = false;
  showFinalBtn = false;
  showcompleteBtn = true;
  userForm: FormGroup;
  garantorsForm: FormGroup;
  securityForm: FormGroup;
  state: string;
  header: string;
  showUserForm = true;
  showGarantorForm = false;
  showSecurityForm = false;
  nextGarantorForm = false;
  nextSecurityForm = false;
  serviceErrors: any = {};
  value: string;
  fieldType: boolean;
  User = this.authService.loggedInUserInfo();
  guarantors = [];
  securities = [];
  data = [{}, [[],[]]];
  txns: any;
  phoneNumbers: Array<string> = [];
  garantorsPhotoUrl: string;
  securityPhotoUrl: string;
  securityTypes: any;
  customers: any;
  stations: any;
  stationLocationId: number;
  checkedClient: MicroLoanClient;
  checkedStation: any;
  values: any;
  numberValue: number;
  canLend: boolean;
  amountBorrowed: any;
  selectionKind: number;
  selectionData: any;
  modalTitle: string;
  armoCycles = [
    {name: 'DAILY', code: 1}, {name: 'WEEKLY', code: 2},
    {name: 'FORTNIGHTLY', code: 3}, {name: 'MONTHLY', code: 4},
    {name: 'QUARTERLY', code: 5}, {name: 'HALF YEARLY', code: 6},
    {name: 'ANNUALLY', code: 7}, {name: 'BIANNUALLY', code: 8},
  ];
  armoTypes = [
    {name: 'FLAT RATE', code: 1},
    {name: 'REDUCING BALANCE WITH REDUCING INSTALMENT', code: 2},
    {name: 'REDUCING BALANCE WITH CONSTANT INSTALMENT', code: 3},
  ];
  constructor(
    private authService: AuthServiceService,
    private others: OthersService,
    private spinner: NgxSpinnerService,
    private router: Router,
    private alertService: AlertService,
    private storage: AngularFireStorage,
    private modalService: BsModalService
  ) {}

  ngOnInit(): void {
    this.errored = false;
    this.showSecurityForm = false;
    this.posted = false;
    this.header = 'Loan Details';
    this.userForm = this.createFormGroup();
    this.garantorsForm = this.garantorsFormGroup();
    this.securityForm = this.securityFormGroup();
    this.others
      .getAllTheStationLocationsByTown(this.User.userLocationId)
      .subscribe(
        (res) => {
          this.stations = res;
          // tslint:disable-next-line: only-arrow-functions
        },
        (err) => {
          //  //console.log(err)
        }
      );
    this.others.getSecurityType().subscribe(
      (res) => {
        this.securityTypes = res;
      },
      (err) => {
        this.errored = true;
        this.alertService.danger({
          html: '<b>' + err + '</b>',
        });
      }
    );
    this.others.getTxnDetails().subscribe(
      (res) => {
        this.txns = res;
        // console.log(res);
      },
      (err) => {
        this.errored = true;
        this.alertService.danger({
          html: '<b>' + err + '</b>',
        });
      }
    );
    this.others.getMicroCustomersByTown(this.User.userLocationId).subscribe(
      (res) => {
        if (res.length > 0) {
          this.customers = res;
          this.phoneNumbers = [];
          this.checkedClient = null;
          this.customers.forEach((customer) => {
            this.phoneNumbers.push(customer.customerPhone1);
          });
        } else {
          this.errored = true;
          this.showUserForm = false;
          this.showGarantorForm = false;
          this.showSecurityForm = false;
          this.alertService.danger({
            html: '<b>There are no Micro Loan customers registered</b>',
          });
        }
      },
      (err) => {
        this.errored = true;
        // console.log(err);
        this.alertService.danger({
          html: '<b>' + err + '</b>',
        });
      }
    );
  }
  createFormGroup(): any {
    return new FormGroup({
      loanPurpose: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      cycle: new FormControl(
        4,
        Validators.compose([Validators.required])
      ),
      type: new FormControl(
        1,
        Validators.compose([Validators.required])
      ),
      itemRate: new FormControl(
        10,
        Validators.compose([Validators.required])
      ),
      tenure: new FormControl(
        1,
        Validators.compose([Validators.required, CustomValidator.maxValue(100)])
      ),
      date: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      amount_to_pay: new FormControl(
        { value: '', disabled: false },
        Validators.compose([
          Validators.required,
          CustomValidator.patternValidator(/\d/, { hasNumber: true }),
          // Validators.maxLength(6),
          // Validators.minLength(3),
        ])
      ),
      pin: new FormControl(
        { value: '', disabled: false },
        Validators.compose([
          Validators.required,
          CustomValidator.patternValidator(/\d/, { hasNumber: true }),
          Validators.maxLength(4),
          Validators.minLength(4),
        ])
      ),
    });
  }
  garantorsFormGroup(): any {
    return new FormGroup({
      name: new FormControl('', Validators.compose([Validators.required])),
      main_contact_number1: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          CustomValidator.patternValidator(
            /^(([0-9])([0-9])([0-9])([0-9])([0-9])([0-9])([0-9])([0-9])([0-9])([0-9]))$/,
            { hasNumber: true }
          ),
        ])
      ),
      main_contact_number2: new FormControl(
        '',
        Validators.compose([
          CustomValidator.patternValidator(
            /^(([0-9])([0-9])([0-9])([0-9])([0-9])([0-9])([0-9])([0-9])([0-9])([0-9]))$/,
            { hasNumber: true }
          ),
        ])
      ),
      url: new FormControl('', Validators.compose([Validators.required])),
      currentResidence: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      currentBusinesstype: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
      businessLocation: new FormControl(
        '',
        Validators.compose([Validators.required])
      ),
    });
  }
  securityFormGroup(): any {
    return new FormGroup({
      type: new FormControl('', Validators.compose([Validators.required])),
      name: new FormControl('', Validators.compose([Validators.required])),
      location: new FormControl('', Validators.compose([Validators.required])),
      url: new FormControl('', Validators.compose([Validators.required])),
    });
  }

  refresh(): any {
    location.reload();
  }
  getStatement(): void {

  }

  checkLimit(val: any): void {
    this.amountBorrowed = val;
  }

  getResult(res: any): void {
   this.checkedClient = res;
   this.fval.cycle.setValue(this.checkedClient.microloanCustomerAmortCyle);
   this.fval.type.setValue(this.checkedClient.microloanCustomerAmortType);
   this.fval.itemRate.setValue(this.checkedClient.microloanCustomerLoanInterest);
   this.fval.tenure.setValue(this.checkedClient.microloanCustomerLoanTenure);
   this.modalRef.hide();
  }
  getClose(res: any): void {
    this.modalRef.hide();
  }

  selectFromData(template: TemplateRef<any>, kind: number): void {
    if (kind === 100) {
      this.openModal(template);
      this.selectionKind = kind;
      this.selectionData = this.customers;
      this.modalTitle = "Select a Client";
    }
  }
  onFileSelected(event): any {
    let folder: string;
    switch (event.target.id) {
      case 'guarantorUrl':
        folder = 'clientImages/microLoan/guarantors';
        this.upload(event.target.id, event.target.files[0], folder);
        break;
      case 'securityUrl':
        folder = 'clientImages/microLoan/securities';
        this.upload(event.target.id, event.target.files[0], folder);
        break;
    }
  }
  upload(inputType: string, getFile: any, path: any): any {
    const n = this.checkedClient.customerId + this.garantorFval.name.value.toLowerCase().replace(/\s+/g, '') || Date.now();
    const file = getFile;
    const filePath = `${path}/${n}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);
    const result = task
      .snapshotChanges()
      .pipe(
        finalize(() => {
          const downloadURL = fileRef.getDownloadURL();
          downloadURL.subscribe((url) => {
            if (url) {
              switch (inputType) {
                case 'guarantorUrl':
                  this.garantorsPhotoUrl = url;
                  // console.log(this.garantorsPhotoUrl);
                  break;
                case 'securityUrl':
                  this.securityPhotoUrl = url;
                  // console.log(this.securityPhotoUrl);
                  break;
              }
            }
          });
        })
      )
      .subscribe((url) => {
        if (url) {
          // console.log(url);
        }
      });
  }

  goBack(): any {
    this.fval.productCode.setValue(this.fval.productCode.value);
    this.showFinalBtn = false;
    this.showcompleteBtn = true;
    this.errored = false;
  }
  cancelForm(): any {
    if (this.showUserForm) {
      this.showUserForm = true;
      this.showGarantorForm = false;
      this.showSecurityForm = false;
      this.header = 'Loan Details';
      this.router.navigate(['/townmanagement']).then();
    } else if (this.showGarantorForm) {
      this.showUserForm = true;
      this.showGarantorForm = false;
      this.showSecurityForm = false;
      this.header = 'Loan Details';
    } else if (this.showSecurityForm) {
      if(this.data[1][0].length) {
        this.data[1][0].pop()
        this.guarantors.pop()
      }
      this.showUserForm = false;
      this.showGarantorForm = true;
      this.showSecurityForm = false;
      this.header = "Guarantor's Form";
    }
  }
  // toggle visibility of password field
  toggleFieldType(): any {
    this.fieldType = !this.fieldType;
  }

  // modal
  public openModal(template: TemplateRef<any>): any {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'modal-xl modal-dialog-centered' })
    );
  }

  revert(): any {
    this.userForm.reset();
  }

  get fval(): any {
    return this.userForm.controls;
  }
  get garantorFval(): any {
    return this.garantorsForm.controls;
  }
  get securityFval(): any {
    return this.securityForm.controls;
  }
  onKey(event: any): any {
    // without type info
    this.values = event.target.value.toString().replace(/[\D\s._\-]+/g, '');

    this.numberValue = this.values ? parseInt(this.values, 10) : 0;

    // tslint:disable-next-line:no-unused-expression
    this.values = this.numberValue === 0 ? '' : this.numberValue.toLocaleString('en-US');
    this.fval.amount_to_pay.setValue(this.values);
  }
  assignTxnId(familyName: string, typeName: string): number {
    for (const txn of this.txns) {
      if (
        txn.txnDetailsFamilyName.toUpperCase() === familyName &&
        txn.txnDetailsTypeName.toUpperCase() === typeName
      ) {
        return txn.txnDetailsId;
      }
    }
  }

  saveAndNew(): any {
    if (this.showUserForm) {
      if (Number(this.fval.pin.value) === this.checkedClient.customerSecretPin) {
        const txn = {
          txnAmount: parseInt(
            this.fval.amount_to_pay.value.toString().replace(/[\D\s\._\-]+/g, ''),
            10
          ),
          customerId: this.checkedClient.customerId,
          txnDetailsId: this.assignTxnId('MICROLOAN', 'LOANDISBURSEMENT'),
          userId: this.User.userId,
          productCode: 400,
          microLoanPurpose: this.fval.loanPurpose.value.toUpperCase(),
          theStationLocationId: this.checkedClient.fktheStationLocationIdCustomer,
          txnDate: `${this.fval.date.value.getFullYear()}-${this.fval.date.value.getMonth() + 1}-${this.fval.date.value.getDate()}`,
          microloanCustomerAmortType: this.fval.type.value,
          microloanCustomerAmortCyle: this.fval.cycle.value,
          interestRateUsed: this.fval.itemRate.value,
          microloanCustomerLoanTenure: this.fval.tenure.value,
        };
        if (txn.txnDetailsId) {
          this.data[0] = txn;
          this.posted = true;
          this.spinner.hide();
          this.alertService.success({
            html: '<b> Saved successfully</b>',
          });
          this.showUserForm = false;
          this.showGarantorForm = true;
          this.header = "Guarantor's Form ";
        } else {
          this.spinner.hide();
          return;
        }
      } else {
        this.errored = true;
        this.spinner.hide();
        this.alertService.danger({
          html: '<b>Secret pin does not much</b>',
        });
      }
    } else if (this.showGarantorForm) {
      setTimeout(() => {
        this.guarantors.push({
          microLoanGuarantorName: this.garantorFval.name.value.toUpperCase(),
          microLoanGuarantorPhone1: this.garantorFval.main_contact_number1.value.toUpperCase(),
          microLoanGuarantorPhone2:
            this.garantorFval.main_contact_number2.value === ''
              ? this.garantorFval.main_contact_number1.value
              : this.garantorFval.main_contact_number2.value,
          microLoanGuarantorPlaceOfResidense: this.garantorFval.currentResidence.value.toUpperCase(),
          microLoanGuarantorTypeOfBusiness: this.garantorFval.currentBusinesstype.value.toUpperCase(),
          microLoanGuarantorBusinessLocation: this.garantorFval.businessLocation.value.toUpperCase(),
          microLoanGuarantorPhotoUrl: this.garantorsPhotoUrl,
        });
        // console.log(this.guarantors);
        this.posted = true;
        // this.spinner.hide();
        this.alertService.success({
          html: '<b> Saved successfully</b>',
        });
        this.garantorsForm = this.garantorsFormGroup();
      }, 1000);
    } else if (this.showSecurityForm) {
      setTimeout(() => {
        const security = {
          securityTypeCode: this.securityFval.type.value,
          microLoanSecurityName: this.securityFval.name.value.toUpperCase(),
          microLoanSecurityLocation: this.securityFval.location.value.toUpperCase(),
          microLoanSecurityPhotoUrl: this.securityPhotoUrl,
        };
        if (security.securityTypeCode) {
          this.securities.push(security);
          // console.log(this.securities);
          this.posted = true;
          // this.spinner.hide();
          this.alertService.success({
            html: '<b> Saved successfully</b>',
          });
          this.securityForm = this.securityFormGroup();
        } else {
          this.errored = true;
          this.alertService.danger({
            html: '<b> The security Type chosen does not exist</b>',
          });
        }
      }, 3000);
    }
  }
  saveAndNext(): any {
    if (this.showGarantorForm) {
      setTimeout(() => {
        this.guarantors.push({
          microLoanGuarantorName: this.garantorFval.name.value.toUpperCase(),
          microLoanGuarantorPhone1: this.garantorFval.main_contact_number1.value.toUpperCase(),
          microLoanGuarantorPhone2:
            this.garantorFval.main_contact_number2.value === ''
              ? this.garantorFval.main_contact_number1.value
              : this.garantorFval.main_contact_number2.value,
          microLoanGuarantorPlaceOfResidense: this.garantorFval.currentResidence.value.toUpperCase(),
          microLoanGuarantorTypeOfBusiness: this.garantorFval.currentBusinesstype.value.toUpperCase(),
          microLoanGuarantorBusinessLocation: this.garantorFval.businessLocation.value.toUpperCase(),
          microLoanGuarantorPhotoUrl: this.garantorsPhotoUrl,
        });
        // console.log(this.guarantors);
        this.posted = true;
        // this.spinner.hide();
        this.alertService.success({
          html: '<b> Saved successfully</b>',
        });
        this.showGarantorForm = false;
        this.showSecurityForm = true;
        this.header = 'Security Form';
        if(this.data[1][1].length) {
          this.data[1][1].pop()
          this.securities.pop()
        }
      }, 1000);
    } else if (this.showSecurityForm) {
      setTimeout(() => {
        const security = {
          securityTypeCode: this.securityFval.type.value,
          microLoanSecurityName: this.securityFval.name.value.toUpperCase(),
          microLoanSecurityLocation: this.securityFval.location.value.toUpperCase(),
          microLoanSecurityPhotoUrl: this.securityPhotoUrl,
        };
        if (security.securityTypeCode) {
          this.securities.push(security);
          this.postLoan();
          this.spinner.hide();
        } else {
          this.errored = true;
          this.alertService.danger({
            html: '<b> The security Type chosen does not exist</b>',
          });
        }
      }, 3000);
    }
  }
  skip(): any {
    if (this.showGarantorForm) {
      this.showGarantorForm = false;
      this.showSecurityForm = true;
      this.header = 'Security Form';
    } else if (this.showSecurityForm) {
      this.postLoan();
    }
  }

  postLoan(): any {
    this.data[1] = []
    this.data[1][0] = [...this.guarantors]
    this.data[1][1] = [...this.securities]
    if (this.checkedClient.customerId) {
      this.others.createMicroLoan(this.data).subscribe(
        (res) => {
          if (res) {
            this.posted = true;
            this.spinner.hide();
            this.alertService.success({
              html:
                '<b> Loan was initiated successfully, wait for approval and confirm</b>',
            });
            this.spinner.hide();
            setTimeout(() => {
              this.router.navigate(['/townmanagement/microloan/confirm']).then();
            }, 3000);
          }
        },
        (err) => {
          this.errored = true;
          this.spinner.hide();
          this.alertService.danger({
            html: '<b>' + err + '</b>',
          });
        }
      );
    } else {
      this.errored = true;
      this.alertService.danger({
        html: '<b>Please select a customer</b>'
      });
    }
  }
}
